import { useEffect } from "react";

const DEFAULT_TITLE = "Vision Era Construction — Industrial Flooring & Stucco GTA";
const DEFAULT_DESC =
  "Greater Toronto Area specialty contractor for industrial resinous, residential epoxy chip-flake, food-grade urethane and exterior stucco. Request a quote.";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, image, path }) {
  useEffect(() => {
    const finalTitle = title ? `${title} · Vision Era Construction` : DEFAULT_TITLE;
    const finalDesc = description || DEFAULT_DESC;
    const url = (typeof window !== "undefined" ? window.location.origin : "") + (path || "");
    document.title = finalTitle;

    setMeta("description", finalDesc);
    setMeta("og:title", finalTitle, "property");
    setMeta("og:description", finalDesc, "property");
    setMeta("og:type", "website", "property");
    if (url) setMeta("og:url", url, "property");
    if (image) setMeta("og:image", image, "property");

    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", finalTitle);
    setMeta("twitter:description", finalDesc);
    if (image) setMeta("twitter:image", image);
  }, [title, description, image, path]);

  return null;
}
